export default __webpack_public_path__ + "static/assets/6a2a7a22fe73ea260145993eb02a91e5.svg";